import { getSampleImagesForDevice, generateSampleSnapshots, getSampleSensorData } from '../../utils/sampleImageUtils';

export const cameraMock = {
  id: "cam-001",
  name: "Top-Down Camera - Tray 3",
  description: "Primary monitoring camera for carnivorous plant collection",
  latestImageUrl: getSampleImagesForDevice('camera').primary,
  thumbnailUrl: getSampleImagesForDevice('camera').primary,
  plants: [
    {
      id: "plant-001",
      name: "Monstera Deliciosa",
      species: "Monstera deliciosa",
      boundingBox: { x: 100, y: 150, width: 120, height: 180 },
      health: "excellent",
      growthStage: "mature",
      lastWatered: "2024-01-15T10:30:00Z",
      notes: "Thriving in current conditions",
      careHistory: [
        { date: "2024-01-15", action: "Watered", notes: "Soil was dry" },
        { date: "2024-01-12", action: "Fertilized", notes: "Spring feeding" },
        { date: "2024-01-08", action: "Pruned", notes: "Removed dead leaves" }
      ]
    },
    {
      id: "plant-002",
      name: "Pothos",
      species: "Epipremnum aureum",
      boundingBox: { x: 350, y: 200, width: 80, height: 120 },
      health: "good",
      growthStage: "growing",
      lastWatered: "2024-01-14T14:20:00Z",
      notes: "New leaves emerging",
      careHistory: [
        { date: "2024-01-14", action: "Watered", notes: "Regular watering" },
        { date: "2024-01-10", action: "Repotted", notes: "Upgraded pot size" },
        { date: "2024-01-05", action: "Fertilized", notes: "Monthly feeding" }
      ]
    },
    {
      id: "plant-003",
      name: "Fiddle Leaf Fig",
      species: "Ficus lyrata",
      boundingBox: { x: 600, y: 100, width: 150, height: 200 },
      health: "warning",
      growthStage: "mature",
      lastWatered: "2024-01-13T09:15:00Z",
      notes: "Slight yellowing on lower leaves",
      careHistory: [
        { date: "2024-01-13", action: "Watered", notes: "Reduced watering frequency" },
        { date: "2024-01-09", action: "Inspected", notes: "Checking for pests" },
        { date: "2024-01-06", action: "Moved", notes: "Better light exposure" }
      ]
    },
    {
      id: "plant-004",
      name: "Venus Flytrap",
      species: "Dionaea muscipula",
      boundingBox: { x: 200, y: 300, width: 60, height: 80 },
      health: "excellent",
      growthStage: "flowering",
      lastWatered: "2024-01-15T08:00:00Z",
      notes: "Flower stalk developing",
      careHistory: [
        { date: "2024-01-15", action: "Watered", notes: "Distilled water only" },
        { date: "2024-01-12", action: "Fed", notes: "Small insect captured" },
        { date: "2024-01-08", action: "Pruned", notes: "Removed old traps" }
      ]
    }
  ],
  sensors: getSampleSensorData('camera'),
  snapshots: generateSampleSnapshots('camera', 4),
  timeRanges: [
    { value: "1h", label: "1 Hour" },
    { value: "6h", label: "6 Hours" },
    { value: "24h", label: "24 Hours" },
    { value: "7d", label: "7 Days" },
    { value: "30d", label: "30 Days" }
  ]
};

export const getPlantHealthColor = (health) => {
  const healthColors = {
    excellent: "#4CAF50",
    good: "#FF9800", 
    warning: "#F44336",
    critical: "#9C27B0"
  };
  return healthColors[health] || "#9E9E9E";
};

export const getPlantHealthIcon = (health) => {
  const healthIcons = {
    excellent: "ri-check-line",
    good: "ri-information-line",
    warning: "ri-error-warning-line",
    critical: "ri-error-warning-fill"
  };
  return healthIcons[health] || "ri-question-line";
};

export const getGrowthStageColor = (stage) => {
  const stageColors = {
    seedling: "#FF9800",
    growing: "#4CAF50",
    mature: "#2196F3",
    flowering: "#E91E63",
    dormant: "#9E9E9E"
  };
  return stageColors[stage] || "#9E9E9E";
}; 